export default "__VITE_ASSET__u0MdJXh7__"